import {Component, EventEmitter, Output} from '@angular/core';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';

@Component({
  selector: 'yu-filter-wrapper',
  templateUrl: './filter-wrapper.component.html',
  styleUrls: ['./filter-wrapper.component.scss'],
  standalone: false
})
export class FilterWrapperComponent {

  @Output() cleanFilters = new EventEmitter<any>();

  constructor(
    protected hapticsImpactManager: HapticsImpactManagerService,
  ) {
  }

  /**
   * Limpiar filtros
   *
   */
  cleanFiltersAction() {
    this.hapticsImpactManager.hapticsImpactMedium();
    this.cleanFilters.emit()
  }

}
